var app = angular.module("leonardo");

var AccountUserRoleForm = function($scope, $rootScope, ngDialog, AccountUserService, AccountUserRoleService, PermissionService,
                                   $state, FormErrorsService, AuthDataService, SectorRestService, $q, $timeout, $filter,
                                   ContactTypeRestService) {

  $scope.permissionService = PermissionService;

  $scope.authDataService = AuthDataService;

  $scope.role = $scope.$parent.roleElement ? $scope.$parent.roleElement.plain() :
    {
      account: AccountUserService.currentAccountUser.account,
      client_instance: AuthDataService.getClientInstance(),
      //white_label: AuthDataService.getWhiteLabel(),
      permissions : {}
    };

  $scope.sectorRestService = SectorRestService;
  $scope.contactTypeRestService = ContactTypeRestService;

  $scope.currentRole = false;

  $scope.roles = AuthDataService.getRolesValid(AccountUserService.currentAccountUser.account);

  $scope.owners = [];

  angular.forEach(AccountUserService.currentAccountUsers, function (account_user) {
    if (account_user.is_owner) {
      $scope.owners.push(account_user.account);
    }
  });

  if (($scope.owners.length > 1) && AuthDataService.isNotStaff() && !$scope.$parent.role) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/account/select.html',
      controller: 'SelectAccountDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        availableAccounts: $scope.owners
      }
    }).then(function (account) {
      if (account) {
        $scope.role.account = account;
      }
      else {
        $timeout(function () {
          $state.go('users.roles');
        }, 100);
      }
    }, function () {
      $timeout(function () {
        $state.go('users.roles');
      }, 100);
    });
  }

  $scope.initRole = function () {
    if (!$scope.role.permissions) {
      $scope.role.permissions = {};
    }
    angular.forEach(PermissionService.permissions, function(permission) {
      $scope.role.permissions[permission] = ($scope.role.permissions[permission] &&
        PermissionService.permissionAvailable(permission, $scope.role)) ? $scope.role.permissions[permission] : false;
    });
    var visible_roles = [];
    angular.forEach($scope.role.visible_roles, function (role) {
      visible_roles.push(role.id);
    });
    $scope.role.visible_roles = visible_roles;
    var editable_roles = [];
    angular.forEach($scope.role.editable_roles, function (role) {
      editable_roles.push(role.id);
    });
    $scope.role.editable_roles = editable_roles;
    var categories = [];
    angular.forEach($scope.role.categories, function(item) {
      categories.push(item.id);
    });
    $scope.role.categories = categories;
    if ($scope.role.contact_type && $scope.role.contact_type.id) {
      $scope.role.contact_type = $scope.role.contact_type.id;
    }
  };

  $scope.onChangeEditTemplate = function(){
    if($scope.role.permissions.permission_edit_template) {
      $scope.role.permissions.permission_deactivate_template = true;
    }
  };

  $scope.onChangeDeactivateTemplate = function(){
    if(!$scope.role.permissions.permission_deactivate_template) {
      $scope.role.permissions.permission_edit_template = false;
    }
  };

  $scope.getPermissionKeys = function(group) {
    var keys = [];
    angular.forEach(PermissionService.permissions, function (key) {
      if (_.contains(key, 'permission_') && !_.contains(key, '_all_') &&  _.contains(key, group))
        keys.push(key);
    });
    return keys;
  };

  $scope.getClassPermissionsAll = function (group) {
    if (group == 'all') {
      $scope.role.permissions.permission_all = true;
      angular.forEach(PermissionService.permissions, function (permission) {
        if (PermissionService.permissionAvailable(permission) && !$scope.role.permissions[permission]) {
          $scope.role.permissions.permission_all = false;
        }
      });
      if ($scope.role.permissions.permission_all) {
        return 'active';
      }
      else {
        return '';
      }
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      var active = true;
      angular.forEach(keys, function (key) {
        if (PermissionService.permissionAvailable(key) && !$scope.role.permissions[key]) {
          active = false;
        }
      });
      if (active) {
        $scope.role.permissions['permission_all_' + group] = true;
        return 'active';
      }
      else {
        $scope.role.permissions['permission_all_' + group] = false;
        return '';
      }
    }
  };

  $scope.deselectOther = function(isChecked) {
    if(isChecked) {
      let keys = ['permission_add_property', 'permission_edit_property', 'permission_delete_property'];
      $scope.assignKeyPermissionValue(keys);
    }
  };

  $scope.assignKeyPermissionValue = function(keys){
    angular.forEach(keys, function (key) {
      if (PermissionService.permissionAvailable(key)) {
        $scope.role.permissions[key] = false;
      }
    });
  }

  $scope.unCheckReadOnlyPermission = function(isChecked) {
    if(isChecked) {
      $scope.role.permissions['permission_read_only_property'] = false;
    }
  }
    
  $scope.selectAllPermissions = function (group) {
    if (group == 'all') {
      if (!$scope.role.permissions.permission_all) {
        angular.forEach(PermissionService.permissions, function (permission) {
          if (PermissionService.permissionAvailable(permission)) {
            $scope.role.permissions[permission] = true;
          }
        });
      }
      else {
        angular.forEach(PermissionService.permissions, function (permission) {
          $scope.role.permissions[permission] = false;
        });
      }
      $scope.role.permissions.permission_all = !$scope.role.permissions.permission_all;
      $scope.role.permissions['permission_read_only_property'] = false;
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      if (!$scope.role.permissions['permission_all_' + group]) {
        angular.forEach(keys, function (key) {
          if (PermissionService.permissionAvailable(key)) {
            $scope.role.permissions[key] = true;
          }
        });
      }
      else {
        $scope.assignKeyPermissionValue(keys);
      }
      if(group === 'property') {
        $scope.role.permissions['permission_read_only_property'] = false;
      }
        
    }
  };

  $scope.getData = function () {
    var data = angular.copy($scope.role);
    var permissions = {};
    angular.forEach(data.permissions, function (value, key) {
      if (!_.includes(key, '_all')) {
        permissions[key] = value ? true : false;
      }
    });
    data.permissions = permissions;
    if (data.contact_type && data.contact_type.id) {
      data.contact_type = data.contact_type.id;
    } else if (!data.contact_type) {
      data.contact_type = null;
    }
    if (data.visible_roles) {
      data.visible_roles = angular.isArray(data.visible_roles) ? data.visible_roles : data.visible_roles.split(',');
    }
    else {
      data.visible_roles = [];
    }
    if (data.editable_roles) {
      data.editable_roles = angular.isArray(data.editable_roles) ? data.editable_roles : data.editable_roles.split(',');
    }
    else {
      data.editable_roles = [];
    }
    if (!data.id) {
      data.include_self_visible = _.contains(data.visible_roles, '-1');
      data.include_self_editable = _.contains(data.editable_roles, '-1');
      if (data.include_self_visible) {
        data.visible_roles.splice(data.visible_roles.indexOf('-1'), 1);
      }
      if (data.include_self_editable) {
        data.editable_roles.splice(data.editable_roles.indexOf('-1'), 1);
      }
    }
    return data;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.$parent.role){
      if (AuthDataService.isNotStaff()) {
        AccountUserService.getlist({
          essential:true,
          disable_pagination:true,
          role: $scope.role.id,
          role_permissions_modified: true,
          active:true
        }).then(function(accounts_users) {
          var results = accounts_users.results ? accounts_users.results : accounts_users;
          if (results.length > 0) {
            ngDialog.openConfirm({
              template: 'views/templates/dialog/account-user/role-modified.html',
              controller: 'RoleModifiedDialog',
              data: {
                role: $scope.role,
                account_users: results
              }
            }).then(function (ids) {
              data.account_users_to_overwrite = ids;
              $scope.updateAccountUserRole($scope.role.id, data);
            });
          }
          else {
            $scope.updateAccountUserRole($scope.role.id, data);
          }
        });
      }
      else {
        $scope.updateAccountUserRole($scope.role.id, data);
      }
    }
    else {
      AccountUserRoleService.post(data).then(function(result){
        AccountUserRoleService.updateCollection(result);
        AccountUserService.updateVisibleRoles(result);
        $state.go('users.roles');
      });
    }
  };

  $scope.updateAccountUserRole = function(id, dataObj){
    AccountUserRoleService.one(id).patch(dataObj).then(function(result){
      AccountUserRoleService.updateCollection(result);
      $rootScope.$broadcast('account-user-roles:updated');
    });
  };

  $scope.$watch('role.name', function (newValue) {
    var index = -1;
    var id = $scope.role.id ? $scope.role.id : '-1';
    $q.when($scope.roles).then((roles) => {
      if (angular.isArray(roles)) {
        angular.forEach(roles, function (role, key) {
          if (role.id == id) {
            index = key;
          }
        });
        if (newValue && (newValue.length > 0)) {
          if (index >= 0) {
            roles[index].name = newValue;
          }
          else {
            roles.push({ id: '-1', name: newValue });
          }
        }
        else {
          if (index >= 0) {
            if (id >= 0) {
              roles[index].name = '-';
            }
            else {
              roles.splice(index, 1);
            }
          }
        }
      }
      $scope.roles = $filter('orderBy')(roles, 'name');
    });
  });

  $scope.initRole();

};

app.controller('AccountUserRoleForm', ['$scope', '$rootScope', 'ngDialog', 'AccountUserService', 'AccountUserRoleService',
  'PermissionService', '$state', 'FormErrorsService', 'AuthDataService', 'SectorRestService', '$q', '$timeout', '$filter',
  'ContactTypeRestService', AccountUserRoleForm]);
